// 行业荣誉
<template>
  <div class="honor aboutus-bgColor">
    <AboutBanner title="行业荣誉"></AboutBanner>
    <div class="aboutus-main">
      <van-row class="flex-warp" type="flex" justify="space-between">
        <van-col class="honor-item justify-align-center border-ra8" span="8" v-for='item of honors' :key='item.id'>
          {{item.name}}
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import AboutBanner from '../aboutBanner.vue';
import { getCase } from '@/api/api'
export default {
  components: {
    AboutBanner
  },
  data () {
    return {
      honors: []
    }
  },
  mounted () {
    this.honors = this.storage.myGetItem('honors') || this.getHonors()
  },
  methods: {
    // 获取数据
    async getHonors () {
      try {
        let { data, status, msg } = await getCase('hyry');
        this.honors = data
        this.storage.mySetItem('honors', data)
      } catch (error) {
        this.$toast('网络错误')
      }
    },
  }
}
</script>
<style scoped lang="less">
.honor-item {
  width: 110px;
  height: 70px;
  background: #faf5e8;
  border: 2px solid #cab890;
  padding: 0 8px;
  line-height: 15px;
  font-size: 12px;
  color: #a98535;
  margin-bottom: 15px;
}
</style>